import { combineReducers } from "redux";
import authuserReducer from "./Reducer/auth.reducer";

const rootReducer = combineReducers({
    auth : authuserReducer
});

export default rootReducer;
